export const TIME_TO_HIDE_HIGHLIGHT_AFTER_TTS_WORD_MS = 5000

export const AUDIO_SET_ENABLED = 'AUDIO_SET_ENABLED'          // master switch
export const AUDIO_SET_VAD_ENABLED = 'AUDIO_SET_VAD_ENABLED'  // listening/segmenting
export const AUDIO_SET_STT_ENABLED = 'AUDIO_SET_STT_ENABLED'  // posting to /audioTranscribe
export const AUDIO_START = 'AUDIO_START'
export const AUDIO_STOP = 'AUDIO_STOP'
export const AUDIO_SET_AWAITING_STT_FOLLOWUP = 'AUDIO_SET_AWAITING_STT_FOLLOWUP'
export const AUDIO_FOLLOWUP_SPEECH_STARTED = 'AUDIO_FOLLOWUP_SPEECH_STARTED'
export const AWAITING_STT_FOLLOWUP = 'awaitingSttFollowup'
export const AUDIO_STT_MAX_AUDIO_LENGTH = 10 * 1000

export const SOLE_BOT_NAME_FOLLOWUP_WINDOW_MS = 10 * 1000
export const SOLE_BOT_NAME_FOLLOWUP_TRANSCRIPT_FAILSAFE_MS = 60 * 1000

export const AUDIO_SPEECH_SEGMENT_READY = 'AUDIO_SPEECH_SEGMENT_READY'
export const AUDIO_TRANSCRIBE_REQUEST = 'AUDIO_TRANSCRIBE_REQUEST'
export const AUDIO_TRANSCRIBE_RESULT = 'AUDIO_TRANSCRIBE_RESULT'
export const AUDIO_ERROR = 'AUDIO_ERROR'
export const AUDIO_SET_ROBOT_SPEAKING = 'AUDIO_SET_ROBOT_SPEAKING'
export const AUDIO_SET_HEARING = 'AUDIO_SET_HEARING'
export const AUDIO_SOME_NOISE = 'AUDIO_SOME_NOISE'
export const USER_SAID = 'USER_SAID'
export const TTS_SPEAK_TOKEN = 'TTS_SPEAK_TOKEN'
export const AUDIO_SET_TTS_MOOD = 'AUDIO_SET_TTS_MOOD'
export const AUDIO_SET_TTS_WORD = 'AUDIO_SET_TTS_WORD'
export const AUDIO_SET_TTS_HEALTH = 'AUDIO_SET_TTS_HEALTH'
export const TTS_MOOD = 'ttsMood'
export const TTS_SERVER_OK = 'ttsServerOk'
export const TTS_LAST_ERROR = 'ttsLastError'
export const TTS_LAST_CHECKED_AT = 'ttsLastCheckedAt'

export const HIGHLIGHT_RANGE = 'highlightRange'
export const SET_HIGHLIGHT_RANGE = 'SET_HIGHLIGHT_RANGE'
export const ENABLED = 'enabled'
export const VAD_ENABLED = 'vadEnabled'
export const STT_ENABLED = 'sttEnabled'
export const IS_TRANSCRIBING = 'isTranscribing'
export const LAST_ERROR = 'lastError'
export const ROBOT_SPEAKING = 'robotSpeaking'
export const HEARING = 'hearing' // 'silence' | 'shaky'
